var Backbone, FAQArticleView, FAQTopicView, FaqTopicpageTemplate, dotdotdot,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FaqTopicpageTemplate = require('../../topicpage.html.mustache');

FAQArticleView = require('./article');

dotdotdot = require('../../../../core/frontend/vendor_modules/jQuery/jquery.dotdotdot');

Backbone = require('backbone');

Backbone.$ = $;

FAQTopicView = (function(superClass) {
  extend(FAQTopicView, superClass);

  function FAQTopicView() {
    return FAQTopicView.__super__.constructor.apply(this, arguments);
  }

  FAQTopicView.VIEWID = 1;

  FAQTopicView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.faq';
    this.template = FaqTopicpageTemplate;
    this.breadCrumbView = this.options.breadCrumbView;
    this.container = this.options.container;
    this.contentModel = this.options.contentModel;
    return this.errorContainer = this.options.errorContainer;
  };

  FAQTopicView.prototype.events = {
    "click #topic_explanation": "handleTopicReadMoreClicked"
  };

  FAQTopicView.prototype.render = function(topicId) {
    var data, errorCb, successCallack;
    this.searchId = topicId;
    data = this.getTopicHash();
    if (this.checkTopicId(topicId, data)) {
      return this.constructTopicpage(data);
    } else {
      successCallack = (function(_this) {
        return function(response) {
          return _this.constructTopicpage(response);
        };
      })(this);
      errorCb = (function(_this) {
        return function(data) {
          return _this.errorCallback(data);
        };
      })(this);
      return this.contentModel.fetchContent({
        topicId: topicId,
        searchId: this.searchId,
        category: "topic"
      }, successCallack, errorCb);
    }
  };

  FAQTopicView.prototype.checkTopicId = function(topicId, data) {
    if ((data != null ? data.topic : void 0) != null) {
      return data.topic.id === topicId;
    } else {
      return false;
    }
  };

  FAQTopicView.prototype.getTopicHash = function() {
    var data;
    data = this.contentModel.attributes;
    if ((data != null ? data.topic : void 0) != null) {
      return data;
    } else {
      return null;
    }
  };

  FAQTopicView.prototype.constructTopicpage = function(response) {
    var ref, topicHash;
    if ((response != null ? response.topic : void 0) != null) {
      topicHash = {
        searchId: response.topic.searchId,
        text: (ref = response.topic.text) != null ? ref.replace(/(<([^>]+)>)/ig, "") : void 0
      };
      this.breadCrumbView.addCrumbs(topicHash);
      return this.toHtml(response);
    } else {
      return this.invalidResponseCallback({
        searchId: this.searchId
      });
    }
  };

  FAQTopicView.prototype.toHtml = function(response) {
    var hash, ref;
    if ((response != null ? (ref = response.topic) != null ? ref.text : void 0 : void 0) != null) {
      response.topic.text = response.topic.text.replace(/(<([^>]+)>)/ig, "");
    }
    hash = $.extend(true, {}, response.topic, window.currentUser, {
      showVerticalPageFlow: typeof experiments !== "undefined" && experiments !== null ? experiments.showVerticalPageFlow : void 0
    });
    this.$el.html(toHtml(this.template, hash, this.I18nScope));
    this.breadCrumbView.render();
    this.container.html(this.el);
    return this.renderSummarizedArticle(response);
  };

  FAQTopicView.prototype.renderSummarizedArticle = function(response) {
    var ref, ref1;
    if (((ref = response.topic) != null ? (ref1 = ref.articles) != null ? ref1.length : void 0 : void 0) > 0) {
      return _.each(response.topic.articles, function(article) {
        var articleView;
        articleView = new FAQArticleView({
          'breadCrumbView': this.breadCrumbView,
          'summarized': true,
          'container': $('#topic_explanation', this.el)
        });
        return articleView.toHtml({
          article: article
        });
      });
    }
  };

  FAQTopicView.prototype.handleTopicReadMoreClicked = function(event) {
    var $target, article, data, ref, searchId;
    $target = $(event.target);
    if ($target.is("a.article") || $target.is("a.read-more")) {
      searchId = $target.attr("searchId");
      data = this.getTopicHash();
      if ((searchId != null) && ((data != null ? (ref = data.topic) != null ? ref.articles : void 0 : void 0) != null)) {
        article = _.find(data.topic.articles, function(article) {
          return article.searchId === searchId;
        });
        if (article != null) {
          return this.contentModel.set('article', article, {
            silent: true
          });
        }
      }
    }
  };

  FAQTopicView.prototype.errorCallback = function(data) {
    return Groupon.FAQ.ViewManager.renderErrorHtml({
      container: this.errorContainer,
      query: data.searchId,
      errorHtmlText: "<div data-bhw='faq___" + (encodeURIComponent(data.searchId)) + "___no-results-displayed-for-topics-api-failure' class='noResults'>" + (this.errorText()) + "</div>"
    });
  };

  FAQTopicView.prototype.errorText = function() {
    if (Groupon.FAQ.ViewManager.isV2View()) {
      return I18n.t('js.modules.faq.refresh_browser');
    } else {
      return I18n.t('js.modules.faq.not_found');
    }
  };

  FAQTopicView.prototype.invalidResponseCallback = function(data) {
    return Groupon.FAQ.ViewManager.renderErrorHtml({
      container: this.errorContainer,
      query: data.searchId,
      errorHtmlText: "<div data-bhw='faq___" + (encodeURIComponent(data.searchId)) + "___no-results-displayed-for-topics-api-invalid' class='noResults'>" + (I18n.t('js.modules.faq.not_found')) + "</div>"
    });
  };

  return FAQTopicView;

})(Backbone.View);

module.exports = FAQTopicView;

//# sourceMappingURL=data:application/json;base64,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
